import { Divider } from '@mui/material';

import {
  AutoComplete,
  ButtonGroup,
  Form,
  FormItem,
  Input,
} from '../../../../components';
import {
  type LatencyPeriod,
  LatencyPeriodOptions,
  LatencyMetricTypeOptions,
} from './const';
import { useThroughput } from './hooks/useThroughput';
import { ThroughputCard, ThroughputByModelCard } from './components';

const FILTER_ITEM_CLASS = 'w-full';
const FILTER_ROW_ITEM_CLASS = `${FILTER_ITEM_CLASS} lg:flex-1 lg:min-w-0`;

export const ThroughputTab = () => {
  const {
    form,
    setForm,
    setMetricType,
    agentsOptions,
    throughput,
    throughputSeries,
  } = useThroughput();

  return (
    <>
      <div className="mx-2 sm:mx-4 lg:mx-sm">
        <div className="w-full max-w-screen-2xl mx-auto px-2 sm:px-4 pt-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6 items-start">
            <Form
              key="throughput-filters"
              initialValue={{
                agentId: form.agentId,
                conversationId: form.conversationId,
              }}
              onChange={values =>
                setForm({
                  ...form,
                  agentId: values.agentId ?? '',
                  conversationId: values.conversationId ?? '',
                })
              }
            >
              <div className="flex w-full flex-col gap-md lg:flex-row lg:items-center">
                <FormItem
                  inline
                  compactInline
                  className={FILTER_ROW_ITEM_CLASS}
                  name="agentId"
                  label="Agent:"
                  labelClassName="text-small text-secondary"
                >
                  <AutoComplete className="w-full" options={agentsOptions} />
                </FormItem>
                <FormItem
                  inline
                  compactInline
                  className={FILTER_ROW_ITEM_CLASS}
                  name="conversationId"
                  label="Conversation:"
                  labelClassName="text-small text-secondary"
                >
                  <Input className="w-full" placeholder="conversation id" />
                </FormItem>
              </div>
            </Form>

            <div className="w-full flex items-center lg:justify-end">
              <ButtonGroup
                className="w-full lg:w-auto"
                buttons={LatencyPeriodOptions.map(option => ({
                  action: option.value,
                  label: option.label,
                  active: form.period === option.value,
                }))}
                orientation="horizontal"
                buttonClassName="p-4"
                labelClassName="whitespace-nowrap overflow-hidden text-ellipsis text-small font-semibold text-secondary"
                onClick={action =>
                  setForm({ ...form, period: action as LatencyPeriod })
                }
              />
            </div>
          </div>
        </div>
      </div>

      <Divider className="mx-2 sm:mx-4 lg:mx-sm my-4" />

      <div className="mx-2 sm:mx-4 lg:mx-sm pb-8">
        <div className="w-full max-w-screen-2xl mx-auto px-2 sm:px-4 space-y-4 sm:space-y-6">
          <ThroughputCard
            data={throughput.data}
            loading={throughput.loading}
          />

          <Divider />

          <div className="flex w-full flex-col gap-md lg:flex-row lg:items-end">
            <div className="w-full lg:max-w-xs">
              <div className="text-small text-secondary mb-1">Type:</div>
              <AutoComplete
                className="w-full"
                value={form.metricType}
                options={LatencyMetricTypeOptions}
                onChange={setMetricType}
              />
            </div>
          </div>

          <ThroughputByModelCard
            data={throughputSeries.data}
            loading={throughputSeries.loading}
            period={form.period}
          />
        </div>
      </div>
    </>
  );
};
